import styled from '@emotion/styled';
import { ScrollBarVertical } from 'src/domains/layouts/shared/scrollbar/Scrollbar.style';

const cmsListContainerHeight = 'calc(100vh - 232px)';

export const ListContainer = styled(ScrollBarVertical, { label: 'ListContainer' })`
    min-height: 50px;
    max-height: ${cmsListContainerHeight};
    position: relative;
    flex: 1 0 auto;
    &:empty {
        display: contents;
    }
`;
